import type { Choice } from "./content";

export type ItemResponseFormInputType =
	| "text"
	| "select"
	| "number"
	| "date"
	| "time"
	| "datetime"
	| "email"
	| "currency";

export type ItemResponseFormField = {
	id: string;
	label: string;
	placeholder: string;
	helperText: string;
	inputType: ItemResponseFormInputType;
	options?: Choice[];
	expected_response?: string;
	required?: boolean;
};

export type WordSelectionIncorrectWord = {
	id: string;
	wordIndex: number;
	transcriptWord: string;
	audioWord: string;
};

export type DragDropBlank = {
	id: string;
};

export type ItemCriteria = {
	id?: string;
	name: string;
	description?: string;
	points?: {
		min: number;
		max: number;
	};
	icon?: string;
	maxPoints?: number;
};

export type TextResponseConstraints = {
	minLength?: number;
	maxLength?: number;
};

export type WordLimit = {
	min?: number;
	max?: number;
};

export type RecordingResponseConstraints = {
	minDuration: number;
	maxDuration: number;
};

export type SelectionResponseConstraints = {
	minSelected?: number;
	maxSelected?: number;
};

export type ItemResponse = (
	| {
			type: "text";
			label?: string;
			placeholder?: string;
			constraints?: TextResponseConstraints;
			instruction?: string;
			timeLimit?: number;
			wordLimit?: WordLimit;
	  }
	| {
			type: "form";
			fields: ItemResponseFormField[];
			instruction?: string;
	  }
	| {
			type: "audio";
			instruction?: string;
			prepTime?: number;
			timeLimit?: number;
			timeLimitUnit?: string;
	  }
	| {
			type: "recording";
			instruction?: string;
			prepTime?: number;
			timeLimit?: number;
			timeLimitUnit?: string;
			maxDuration?: number;
	  }
	| {
			type: "choice";
			choices: Choice[];
			shuffle?: boolean;
			constraints?: SelectionResponseConstraints;
			points?: number;
			selectionType?: "single" | "multiple";
			instruction?: string;
			maxCorrectChoices?: number;
			minCorrectChoices?: number;
			correctResponse?: { id: string; order?: number; text?: string }[];
	  }
	| {
			type: "reorder";
			choices?: Choice[];
			instruction?: string;
			correctResponse?: { id: string; order?: number; text?: string }[];
	  }
	| {
			type: "RECORDED_AUDIO";
			instruction?: string;
			prepTime?: number;
			timeLimit?: number;
			timeLimitUnit?: string;
	  }
	| {
			type: "EXTENDED_TEXT";
			instruction?: string;
			timeLimit?: number;
			wordLimit?: WordLimit;
	  }
	| {
			type: "SHORT_TEXT_ENTRY";
			instruction?: string;
			wordLimit?: WordLimit;
	  }
	| {
			type: "writing";
			instruction?: string;
			timeLimit?: number;
			wordLimit?: WordLimit;
	  }
	| {
			type: "OPTION_SELECTION";
			choices: Choice[];
			shuffle?: boolean | null;
			instruction?: string;
	  }
	| {
			type: "INLINE_OPTION_SELECTION";
			instruction?: string;
			blanks: {
				blankId: string;
				choices: Choice[];
			}[];
	  }
	| {
			type: "TOKEN_MAPPING";
			instruction?: string;
			wordBank: Choice[];
	  }
	| {
			type: "INLINE_TEXT_SELECTION";
			instruction?: string;
			incorrectWords?: WordSelectionIncorrectWord[];
	  }
	| {
			type: "ORDER_RECONSTRUCTION";
			instruction?: string;
	  }
) & {
	itemPoints?: number;
	totalPoints?: number;
};
